module.exports = __webpack_public_path__ + "img/outgoing-consignments.13600d2.png";